import { render } from "./RadioWithImage.vue?vue&type=template&id=54f5f70e&scoped=true"
import script from "./RadioWithImage.vue?vue&type=script&lang=js"
export * from "./RadioWithImage.vue?vue&type=script&lang=js"

import "./RadioWithImage.vue?vue&type=style&index=0&id=54f5f70e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f5f70e"]])

export default __exports__